import { motion } from "framer-motion";
import { Button } from "react-bootstrap";
import {AiOutlineArrowUp} from 'react-icons/ai'

export const UpButton = () => {
  
  
  const reachedTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  return (
      <motion.div layout initial={{opacity: 0}} animate={{opacity:1}} transition={{duration: 0.5, type:"spring"}} exit={{opacity:0, x: -200}}>
      <Button id="toTop" onClick={reachedTop}
      ><AiOutlineArrowUp /></Button>
      </motion.div>
  )
}
